import { defineStore } from 'pinia';
import { useChatStore } from './chat';
import { Session } from '/@common/utils/storage';

export const useRobotStore = defineStore('robot-store', {
	state: (): Robot.RobotState => ({
		ws: null,
		getresult: false,
		delayFlag: false,
		chatInterVal: null,
		player: null,
		videoDom: null,
		notShowIndividual: true,
		muted: true,
		personSize: [440,782],
		personPos: [],
		fromUser: '1',
		referX: 1920,
		referY: 1080,
		keyEve: false,
	}),
	actions: {
		async initRobot() {
			let id = Session.get('userId')
			let insurl = window.location.host == 'yayi.wenge.com' ? 'wss://yayi.wenge.com/admin/api/imserver/' : 'wss://stg-yayi.wenge.com/admin/api/imserver/'
			let url = `${insurl + id}`
			this.ws = new heartCheck({},url) 
			this.ws.initWebSocket(this.getsocketResult)
		},
		//获取ws消息
		getsocketResult(data: any){
			this.fromUser = data.fromUser;
			this.getVideostream(data.content)
		},
		getVideostream(data: any){
			//获取推流地址和系统资源情况
			if(data){
				let content = JSON.parse(data);
				if (content.code == 200) {
					if(content.data.pullStreamUrl){
						let pullStreamUrl = content.data.pullStreamUrl;
						this.initVideo(pullStreamUrl);
					}
					
					this.getresult = true
				} else {
					//没有推流的话 如果继续等待
					if (!this.delayFlag) {
						//关闭socket连接
						this.close();
					}
					this.getresult = false
				}
			}
		},
		close(){
			if(this.ws){
				this.ws.closeWebSocket()
			}
		},
		initVideo(url){
			// 播放器存在 清空重置
			if (this.player) {
				this.player.destroy();
				this.player = null;
			}
			// 获取承载元素dom
			this.videoDom = document.getElementById("jswebrtc");
			// 初始化播放器
			this.player = new JSWebrtc.Player(url, {
				video: this.videoDom,
				autoplay: true,
				onPlay: obj => {
					// this.getTransparent();
				}
			});
		},
		getTransparent(){
			let videoWidth = 1080; //视频实际的宽度
			//定义渲染器
			var renderer = new THREE.WebGLRenderer({
			  canvas: document.getElementById("convasVideo"),
			  antialias: false, //抗锯齿效果
			  alpha: true //画布默认是黑色背景，要显示的内容有颜色，这一项设置为true
			});
			renderer.setPixelRatio(window.devicePixelRatio);
			renderer.setClearColor(new THREE.Color("lightgrey"), 0);
			renderer.setSize(this.personSize[0], this.personSize[1]);
	  
			document.getElementById("convasParent").appendChild(renderer.domElement);
			var scene = new THREE.Scene();
			var camera = new THREE.Camera();
			scene.add(camera);
			//播放视频
			var video = document.getElementById("jswebrtc");
			// video.play();
			//获取视频纹理
			var texture = new THREE.VideoTexture(video);
			texture.minFilter = THREE.LinearFilter;
			texture.magFilter = THREE.LinearFilter;
			texture.format = THREE.RGBFormat;
			//定义几何体
			var geometry = new THREE.PlaneBufferGeometry(2, 2);
	  
			//处理视频纹理
			var uniforms = {
			  time: { type: "f", value: 1.0 },
			  texture: { type: "sampler2D", value: texture }
			};
			var material = new THREE.ShaderMaterial({
			  uniforms: uniforms,
			  vertexShader: `varying vec2 vUv;
				void main() {
				  vUv = uv;
				  gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}`,
			  fragmentShader: `#ifdef GL_ES
				precision highp float;
				#endif
				
				uniform float time;
				uniform sampler2D texture;
				varying vec2 vUv;
				
				void main( void ) {
				  gl_FragColor = vec4(
				  texture2D(texture, vec2(vUv.x/2., vUv.y)).rgb,
				  texture2D(texture, vec2(0.5+vUv.x/2., vUv.y)).r
				  );
				}`
			});
			var mesh = new THREE.Mesh(geometry, material);
			scene.add(mesh);
			var animate = function() {
			  requestAnimationFrame(animate);
			  renderer.render(scene, camera);
			};
			requestAnimationFrame(animate);
		},
		breakChat(){
			this.sendtext("break", "break")
		},
		sendtext(msg, type){
			let param = {
				msgId: Math.round(Math.random() * 1000000000000000000).toString(36),
				toUser: Session.get('userId'),
				fromUser: this.fromUser,
				msgType: "text",
				createTime: Number(new Date()),
				content: msg.trim(),
			};
			if (type || msg == 'break') {
				param.systemflag = true;
			}
			if(this.ws){
				let { readyState } = this.ws.webSocket;
				if(readyState == 1){
					//连接状态正常的时候才发送消息 如果发送消息的时候 需要重新计算倒计时
					// this.countDown()
					this.ws.sendSock(JSON.stringify(param))
				}else{
					console.log('长时间未使用连接已断开，请重新加载！')
				}
			}
			return false;
		},
		countDown(){
			//倒计时
			clearInterval(this.chatInterVal);
			let time = process.env.NODE_ENV == "development" ? 600 : 1 * 60 * 60; //暂定时间是1小时
			this.chatInterVal = setInterval(() => {
			// console.log(time, 'time')
			if (time <= 0) {
				clearInterval(this.chatInterVal);
				// 断开连接
				this.ws.closeWebSocket();
			}
			--time;
			}, 1000);
		},
		sendMsg(msg, type){
			useChatStore().isOpen = true
			useChatStore().rightFlag = 2
			//this.breakChat()
			this.sendtext(msg, type)
		}
	},
});
